import styled from "styled-components";
import { Color, Device } from "@styles/constants";
import { SmallBodyRegular } from "@styles/typography";

export const Quantity = styled.div`
  padding-right: 15px;
  font-weight: bold;
`;

export const LineItemInfo = styled.button`
  width: 16px;
  height: 16px;
  display: inline-block;
  position: relative;
  top: 2px;
  margin-left: 0.5rem;
  cursor: pointer;
`;

export const VariantDisplay = styled.div`
  margin-bottom: 1em;
  flex: 0;
  color: ${Color.grayBrand};

  @media ${Device.small} {
    margin: 0.5em 0;
  }
`;

export const VariantText = styled(SmallBodyRegular)`
  padding: 0;
  flex: 0;
  margin-bottom: 0;
`;
